import { SOCKET_OPENED, SOCKET_ERROR, SOCKET_CLOSED, SOCKET_DISCONNECT, SOCKET_CONNECT } from './actions';

export const socketOpened = () => ({type: SOCKET_OPENED});
export const socketError = (err: any) => ({type: SOCKET_ERROR, payload: err});
export const socketClosed = () => ({type: SOCKET_CLOSED});
export const openSocket = () => ({type: SOCKET_CONNECT});
export const disconnectSocket = () => ({type: SOCKET_DISCONNECT});